import { EmoviToGuess } from "../interfaces/EmoviToGuess";

export const ALL_EMOVIS: EmoviToGuess[] = [
  {
    id: "tt0114709",
    emojiText: "🥔🤠👨‍🚀🐊🐖🐶",
  },
  {
    id: "tt0167260",
    emojiText: "💍🌋🧙‍♂️👑",
  },
  {
    id: "tt0103639",
    emojiText: "🧞‍♂️🪔🐒👸🤴",
  },
  {
    id: "tt0211915",
    emojiText: "👩‍🦰🎠🗼🥖🇫🇷",
  },
  {
    id: "tt1745960",
    emojiText: "✈️🇺🇸🕶️",
  },
  {
    id: "tt0109830",
    emojiText: "🏃🍫🦐",
  },
  {
    id: "tt0120382",
    emojiText: "🙍‍♂️🎥⛵😨📺",
  },
  {
    id: "tt4633694",
    emojiText: "🕷️🦸🦹🦸‍♂️🦹‍♂️🦸‍♀️🦹‍♀️🎨✏️",
  },
  {
    id: "tt0090605",
    emojiText: "👽🤰🩸😱",
  },
  {
    id: "tt0062622",
    emojiText: "👁️🖥️🛰️🚀",
  },
  {
    id: "tt0054215",
    emojiText: "🔪🚿🧓",
  },
  {
    id: "tt0101414",
    emojiText: "🌹👸🧌",
  },
  {
    id: "tt0264464",
    emojiText: "🏃‍♂️✈️💰🏃",
  },
  {
    id: "tt0045152",
    emojiText: "☔🎤😃",
  },
  {
    id: "tt0107290",
    emojiText: "🦟💉🥚🦕🦖🚨🏃‍♂️",
  },
  {
    id: "tt0993846",
    emojiText: "🐺🧱🛣️〽️🏦💵",
  },
  {
    id: "tt0382932",
    emojiText: "🐭💆‍♂️👨‍🍳🍲",
  },
  {
    id: "tt10648342",
    emojiText: "🦸🔨❤️➕⛈️",
  },
  {
    id: "tt0482571",
    emojiText: "🏃🚪🎩🚪🏃▶️👬",
  },
  {
    id: "tt2380307",
    emojiText: "🎸💀👦🇲🇽",
  },
  {
    id: "tt0107048",
    emojiText: "🔄⏰🦔",
  },
  {
    id: "tt0133093",
    emojiText: "🕵️🕵️‍♀️🤜🤵🔌💊",
  },
  {
    id: "tt1130884",
    emojiText: "👮‍♂️💊🏝️😨",
  },
  {
    id: "tt2293640",
    emojiText: "🤓🤓🤓🍌🧒",
  },
  {
    id: "tt0114369",
    emojiText: "😋😛😴🤢😡😎🤤👀",
  },
  {
    id: "tt5311514",
    emojiText: "👦💬⁉️↔️⁉️🗨️👧🗾🌊☄️",
  },
  {
    id: "tt0119217",
    emojiText: "🧹🏫👨‍🏫🧠🍎",
  },
  {
    id: "tt12412888",
    emojiText: "🦔👟✌️",
  },
  {
    id: "tt0088763",
    emojiText: "🚗🔙⌚👨‍🔬🙍",
  },
  {
    id: "tt0435761",
    emojiText: "👨‍🚀🤠🏫🍓🧸",
  },
  {
    id: "tt0116629",
    emojiText: "🇺🇸🎆👽👊",
  },
  {
    id: "tt0325980",
    emojiText: "🏴‍☠️🌊💀⚔️⚫📿",
  },
  {
    id: "tt6467266",
    emojiText: "🐷🦍🦁🎹🎧🦔",
  },
  {
    id: "tt1160419",
    emojiText: "👩‍👦🗡️⏳🐛🪐",
  },
  {
    id: "tt0066921",
    emojiText: "👁️🎩🦯🥛🍊",
  },
  {
    id: "tt1049413",
    emojiText: "👴🧒🎈🏠🏞️🐕🔼",
  },
  {
    id: "tt2582802",
    emojiText: "🥁👨‍🦲⏱️🩸🚗📁🎶",
  },
  {
    id: "tt0120338",
    emojiText: "💑🚢🧊🥶👵",
  },
  {
    id: "tt2096673",
    emojiText: "😡😭😊🤢😱🧠",
  },
  {
    id: "tt0050083",
    emojiText: "😠1️⃣2️⃣",
  },
  {
    id: "tt1396484",
    emojiText: "🤡👿🎈",
  },
  {
    id: "tt0073195",
    emojiText: "🦈😱",
  },
  {
    id: "tt0137523",
    emojiText: "🥊♣️🧼",
  },
  {
    id: "tt1877830",
    emojiText: "🦇🐱🐧❓",
  },
  {
    id: "tt0088247",
    emojiText: "🤖🕶️🔫",
  },
  {
    id: "tt0110413",
    emojiText: "🧔🔫🥛👧",
  },
  {
    id: "tt0110912",
    emojiText: "💼🕺💉💃☕⌚",
  },
  {
    id: "tt0083658",
    emojiText: "🗡️🏃‍♂️",
  },
  {
    id: "tt4729430",
    emojiText: "📫🧓🔨🧸🛷",
  },
  {
    id: "tt2382320",
    emojiText: "🚫🕐💀",
  },
  {
    id: "tt1201607",
    emojiText: "👦⚡☠️⚔️2️⃣",
  },
  {
    id: "tt2024544",
    emojiText: "🕛🗓️⛓️",
  },
  {
    id: "tt0095016",
    emojiText: "🗼🎄👨🔫",
  },
  {
    id: "tt0041959",
    emojiText: "🧍‍♂️🧍‍♂️🧍‍♂️⬅️",
  },
  {
    id: "tt0070047",
    emojiText: "✝️🤮🙏",
  },
  {
    id: "tt0266697",
    emojiText: "👱‍♀️⛩️⚔️",
  },
  {
    id: "tt0081505",
    emojiText: "🪓😈🛀",
  },
  {
    id: "tt10298810",
    emojiText: "👨‍🚀🌌",
  },
  {
    id: "tt0167404",
    emojiText: "👁️👀💀🧑‍🤝‍🧑",
  },
  {
    id: "tt9032400",
    emojiText: "🦸‍♂️🌍♾️",
  },
  {
    id: "tt0317705",
    emojiText: "👨‍👩‍👧‍👦🦸ℹ️",
  },
  {
    id: "tt6751668",
    emojiText: "👨‍👩‍👧‍👦💸🇰🇷",
  },
  {
    id: "tt0266543",
    emojiText: "🔎🐟",
  },
  {
    id: "tt4154756",
    emojiText: "♾️⚔️",
  },
  {
    id: "tt0075148",
    emojiText: "🥊",
  },
  {
    id: "tt0112573",
    emojiText: "🏴󠁧󠁢󠁳󠁣󠁴󠁿⚔️😠☠️",
  },
  {
    id: "tt0816692",
    emojiText: "🚀🌊⏲️🌽",
  },
  {
    id: "tt0102926",
    emojiText: "🤐🐑",
  },
  {
    id: "tt0032138",
    emojiText: "🐶👠👠🌪️🏠",
  },
  {
    id: "tt0884328",
    emojiText: "🌫️🛒🌫️",
  },
  {
    id: "tt1375666",
    emojiText: "💤🌀⤴️",
  },
  {
    id: "tt0060196",
    emojiText: "👍👎👹",
  },
  {
    id: "tt0198781",
    emojiText: "🟢👁️🟢👧👹",
  },
  {
    id: "tt0892769",
    emojiText: "⚫🐉🦷",
  },
  {
    id: "tt0910970",
    emojiText: "🌍🗑️🤖🌱❤️",
  },
  {
    id: "tt8503618",
    emojiText: "🇺🇸🎼🗽🎵🔫",
  },
  {
    id: "tt0457430",
    emojiText: "👁️👐👁️",
  },
  {
    id: "tt0118715",
    emojiText: "🎳🥛💼🩲",
  },
  {
    id: "tt0169547",
    emojiText: "🇺🇸💅🌹🌹🌹🌹🌹🌹",
  },
  {
    id: "tt0056172",
    emojiText: "🏇🏜️🗡️",
  },
  {
    id: "tt1345836",
    emojiText: "🦇🤵⬆️",
  },
  {
    id: "tt0102926",
    emojiText: "🔇🐏",
  },
  {
    id: "tt0034583",
    emojiText: "🇫🇷💖🚂😒🕌☕🎹✈️",
  },
  {
    id: "tt1028532",
    emojiText: "🐶🙍‍♂️🚋⏱️",
  },
  {
    id: "tt0119698",
    emojiText: "🐺👸🩸🐗🐛",
  },
  {
    id: "tt0090605",
    emojiText: "🌐👩👧🐱💥👽",
  },
  {
    id: "tt0053291",
    emojiText: "👨‍🦰👨‍🦱👠💄👗",
  },
  {
    id: "tt0110357",
    emojiText: "🦁🐆🐗👑",
  },
  {
    id: "tt0245429",
    emojiText: "🐉😱👹👵⛩️",
  },
  {
    id: "tt0117951",
    emojiText: "💉👬🧑‍🤝‍🧑💊🇬🇧🤪🤮",
  },
  {
    id: "tt7657566",
    emojiText: "👨🔎🇪🇬⛴️☠️",
  },
  {
    id: "tt0096283",
    emojiText: "▶️🚪🏠🐻",
  },
  {
    id: "tt4513678",
    emojiText: "🙍🙍🙍🙍👻🧹",
  },
  {
    id: "tt1464335",
    emojiText: "🗺️🧗‍♂️🚁💰",
  },
  {
    id: "tt0338013",
    emojiText: "💑💔😭💵👨‍🔬😴🧠💻🕵️🙂",
  },
  {
    id: "tt0068646",
    emojiText: "🐴🛏️🩸",
  },
  {
    id: "tt0082971",
    emojiText: "🏜️🕌💼💀🤠",
  },
  {
    id: "tt6264654",
    emojiText: "🎮🔫🧑‍💻⌨️🏦",
  },
  {
    id: "tt0017136",
    emojiText: "🤖🌆🇩🇪🎥",
  },
  {
    id: "tt0120689",
    emojiText: "💀🚶‍♂️🟩🟩🟩",
  },
  {
    id: "tt0111161",
    emojiText: "👨‍⚖️😧♟️⛏️👋",
  },
  {
    id: "tt0172495",
    emojiText: "🤼‍♂️🏟️⚔️👎",
  },
  {
    id: "tt1201607",
    emojiText: "👦⚡🔺💫🚫👃☠️",
  },
  {
    id: "tt8772262",
    emojiText: "💐🔪🐻",
  },
  {
    id: "tt1853728",
    emojiText: "🦷🤠🧐🏇⛓️",
  },
  {
    id: "tt0114814",
    emojiText: "👮‍♂️🤬🔫🕵️‍♂️❔",
  },
  {
    id: "tt0095327",
    emojiText: "👨‍👧⚰️🌌🌂🇯🇵",
  },
  {
    id: "tt0053198",
    emojiText: "👦💔🏃‍♂️🇫🇷",
  },
  {
    id: "tt7286456",
    emojiText: "🔫🤡🃏",
  },
  {
    id: "tt0253474",
    emojiText: "🧑🎹",
  },
  {
    id: "tt11703710",
    emojiText: "🎩👒📽️🎙️🇬🇧",
  },
  {
    id: "tt0057115",
    emojiText: "🇩🇪🕳️⛏️🏍️🚞",
  },
  {
    id: "tt1130884",
    emojiText: "🏝️🧐🏨",
  },
  {
    id: "tt0100157",
    emojiText: "⌨️👩‍🦼🔨👩‍🦰",
  },
  {
    id: "tt15521050",
    emojiText: "❤️🍦",
  },
  {
    id: "tt0076759",
    emojiText: "⭐🔫💣",
  },
  {
    id: "tt0081398",
    emojiText: "😡🐂",
  },
  {
    id: "tt0092099",
    emojiText: "🔝🔫🛩",
  },
  {
    id: "tt0105236",
    emojiText: "🚧🌊🚧🐶",
  },
  {
    id: "tt1050263",
    emojiText: "❄◽",
  },
  {
    id: "tt0106965",
    emojiText: "🆓🐳",
  },
  {
    id: "tt0397892",
    emojiText: "🐶⚡",
  },
  {
    id: "tt11245972",
    emojiText: "😱🔪",
  },
  {
    id: "tt0118571",
    emojiText: "🛩🇺🇸1",
  },
  {
    id: "tt0119654",
    emojiText: "👨🏻⤵⬛👽",
  },
  {
    id: "tt0119695",
    emojiText: "💰👄",
  },
  {
    id: "tt0120632",
    emojiText: "🏙👼🏻👼🏻",
  },
  {
    id: "tt0120812",
    emojiText: "🚗💨🕑",
  },
  {
    id: "tt0250494",
    emojiText: "⚖👩🏼👛🎥",
  },
  {
    id: "tt0375679",
    emojiText: "🚙💥🚗",
  },
  {
    id: "tt0437405",
    emojiText: "📄👨🏻",
  },
  {
    id: "tt0417217",
    emojiText: "2➡💰",
  },
  {
    id: "tt0112431",
    emojiText: "🐷💬🎥",
  },
  {
    id: "tt0086034",
    emojiText: "🐙🐱",
  },
  {
    id: "tt6139732",
    emojiText: "👳🏻🔮🌙",
  },
  {
    id: "tt0053285",
    emojiText: "💤👩🏻",
  },
  {
    id: "tt0096244",
    emojiText: "🍹🌄",
  },
  {
    id: "tt0097239",
    emojiText: "🚘👵🏻🌼",
  },
  {
    id: "tt0253474",
    emojiText: "👨🏻🎹",
  },
  {
    id: "tt9347730",
    emojiText: "🍬👨🏻",
  },
  {
    id: "tt0061852",
    emojiText: "🌴📖",
  },
  {
    id: "tt0111257",
    emojiText: "💣🚌💨💨",
  },
  {
    id: "tt0113117",
    emojiText: "🇫🇷💋",
  },
  {
    id: "tt0039536",
    emojiText: "💋💀",
  },
  {
    id: "tt0050083",
    emojiText: "12😡👨🏻",
  },
  {
    id: "tt1602620",
    emojiText: "👴🏻❤👵🏻",
  },
  {
    id: "tt0133152",
    emojiText: "🌍🐵🐵🐵",
  },
  {
    id: "tt0120338",
    emojiText: "🛳🌊💥",
  },
  {
    id: "tt0157503",
    emojiText: "💧💀👸🏻✨",
  },
  {
    id: "tt0161081",
    emojiText: "❓🛌🏻⬇",
  },
  {
    id: "tt0163187",
    emojiText: "🏃🏻👰🏻",
  },
  {
    id: "tt0175142",
    emojiText: "😱🎬",
  },
  {
    id: "tt0448694",
    emojiText: "😺👢",
  },
  {
    id: "tt4593060",
    emojiText: "👃🏻➡➡➡",
  },
  {
    id: "tt0044706",
    emojiText: "⬆🕛",
  },
  {
    id: "tt0250687",
    emojiText: "🐭🏃🏻🏃🏻🏃🏻",
  },
  {
    id: "tt0259324",
    emojiText: "👻👨🏻🐎",
  },
  {
    id: "tt0259711",
    emojiText: "🍦⛅",
  },
  {
    id: "tt0265086",
    emojiText: "⬛🐦⬇",
  },
  {
    id: "tt1210819",
    emojiText: "1👨🏻🐴",
  },
  {
    id: "tt0960731",
    emojiText: "😴📖",
  },
  {
    id: "tt0358273",
    emojiText: "🚶🏻➡➖➖",
  },
  {
    id: "tt0360717",
    emojiText: "👑🐵😡🏬",
  },
  {
    id: "tt0366548",
    emojiText: "😃👣",
  },
  {
    id: "tt0371746",
    emojiText: "ࠦ👨🏻",
  },
  {
    id: "tt0377471",
    emojiText: "🐝🆒",
  },
  {
    id: "tt0389790",
    emojiText: "🐝🎬",
  },
  {
    id: "tt0396269",
    emojiText: "👰🏻🤵🏻💥💥",
  },
  {
    id: "tt0401792",
    emojiText: "😈😈😈🌇",
  },
  {
    id: "tt0409459",
    emojiText: "⌚👨🏽👨🏽",
  },
  {
    id: "tt0415778",
    emojiText: "🔚🎮",
  },
  {
    id: "tt0417148",
    emojiText: "🐍🐍🛩",
  },
  {
    id: "tt0441773",
    emojiText: "👊🏻💥🐼",
  },
  {
    id: "tt0448157",
    emojiText: "🖐🏻🐓",
  },
  {
    id: "tt0450259",
    emojiText: "💉💎",
  },
  {
    id: "tt0454876",
    emojiText: "👳🏻🚣🏻♂🐅",
  },
  {
    id: "tt0472181",
    emojiText: "🔵👴🏻👧🏻👦🏻",
  },
  {
    id: "tt0499549",
    emojiText: "🔵👽",
  },
  {
    id: "tt0800369",
    emojiText: "⚡🔨💪🏻",
  },
  {
    id: "tt0879870",
    emojiText: "🍜🙏🏻❤",
  },
  {
    id: "tt0942385",
    emojiText: "🌴🍹⚡☔",
  },
  {
    id: "tt0961097",
    emojiText: "👹➡🇫🇷🗼",
  },
  {
    id: "tt0978621",
    emojiText: "🏃🏻💥⬅🚂",
  },
  {
    id: "tt1605783",
    emojiText: "🌃🕛🇫🇷🗼",
  },
  {
    id: "tt1074638",
    emojiText: "⛅🍃",
  },
  {
    id: "tt2103264",
    emojiText: "👑🇨🇳",
  },
  {
    id: "tt1276104",
    emojiText: "👨🏻🔫👦🏻🔄",
  },
  {
    id: "tt1289401",
    emojiText: "👻👻🔫",
  },
  {
    id: "tt1416801",
    emojiText: "🔫➡🍀👨🏻",
  },
  {
    id: "tt1424381",
    emojiText: "🐆🐅🐊",
  },
  {
    id: "tt14403842",
    emojiText: "🔟☔",
  },
  {
    id: "tt1860353",
    emojiText: "🐌💨",
  },
  {
    id: "tt1637725",
    emojiText: "🐻❤🍻🚬",
  },
  {
    id: "tt1790885",
    emojiText: "0🌌30",
  },
  {
    id: "tt1798709",
    emojiText: "👨🏻👓❤📱",
  },
  {
    id: "tt1885300",
    emojiText: "👌🏻👨🏻⬇",
  },
  {
    id: "tt0054215",
    emojiText: "🔪🚿",
  },
  {
    id: "tt1981677",
    emojiText: "🎤🎼💯",
  },
  {
    id: "tt0099785",
    emojiText: "🏠😱🎄👱🏻",
  },
  {
    id: "tt2334879",
    emojiText: "◽🏠⬇",
  },
  {
    id: "tt0021749",
    emojiText: "🏙💡💡",
  },
  {
    id: "tt0105236",
    emojiText: "🚧🌊🚧🐶",
  },
  {
    id: "tt1049413",
    emojiText: "🏠🎈🎈🎈",
  },
  {
    id: "tt0068646",
    emojiText: "🇮🇹😇👴🏻",
  },
  {
    id: "tt0109830",
    emojiText: "🏃🏻🍫🍤",
  },
  {
    id: "tt0137523",
    emojiText: "👊🏻♣",
  },
  {
    id: "tt0266543",
    emojiText: "🔎🐠",
  },
  {
    id: "tt1375666",
    emojiText: "💡➡😴",
  },
  {
    id: "tt0114709",
    emojiText: "🥔🤠👨‍🚀🐊🐖🐶",
  },
  {
    id: "tt0167260",
    emojiText: "💍🌋🧙‍♂️👑",
  },
  {
    id: "tt6139732",
    emojiText: "🧞‍♂️🪔🐒👸🤴",
  },
  {
    id: "tt0211915",
    emojiText: "👩‍🦰🎠🗼🥖🇫🇷",
  },
  {
    id: "tt1745960",
    emojiText: "✈️🇺🇸🕶️",
  },
  {
    id: "tt0109830",
    emojiText: "🏃🍫🦐",
  },
  {
    id: "tt0120382",
    emojiText: "🙍‍♂️🎥⛵😨📺",
  },
  {
    id: "tt4633694",
    emojiText: "🕷️🦸🦹🦸‍♂️🦹‍♂️🦸‍♀️🦹‍♀️🎨✏️",
  },
  {
    id: "tt0090605",
    emojiText: "👽🤰🩸😱",
  },
  {
    id: "tt0062622",
    emojiText: "👁️🖥️🛰️🚀",
  },
  {
    id: "tt0054215",
    emojiText: "🔪🚿🧓",
  },
  {
    id: "tt0101414",
    emojiText: "🌹👸🧌",
  },
  {
    id: "tt0264464",
    emojiText: "🏃‍♂️✈️💰🏃",
  },
  {
    id: "tt0045152",
    emojiText: "☔🎤😃",
  },
  {
    id: "tt0107290",
    emojiText: "🦟💉🥚🦕🦖🚨🏃‍♂️",
  },
  {
    id: "tt0382932",
    emojiText: "🐭💆‍♂️👨‍🍳🍲",
  },
  {
    id: "tt10648342",
    emojiText: "🦸🔨❤️➕⛈️",
  },
  {
    id: "tt0482571",
    emojiText: "🏃🚪🎩🚪🏃▶️👬",
  },
  {
    id: "tt2380307",
    emojiText: "🎸💀👦🇲🇽",
  },
  {
    id: "tt0107048",
    emojiText: "🔄⏰🦔",
  },
  {
    id: "tt0133093",
    emojiText: "🕵️🕵️‍♀️🤜🤵🔌💊",
  },
  {
    id: "tt1130884",
    emojiText: "👮‍♂️💊🏝️😨",
  },
  {
    id: "tt0114369",
    emojiText: "😋😛😴🤢😡😎🤤👀",
  },
  {
    id: "tt5311514",
    emojiText: "👦💬⁉️↔️⁉️🗨️👧🗾🌊☄️",
  },
  {
    id: "tt0119217",
    emojiText: "🧹🏫👨‍🏫🧠🍎",
  },
  {
    id: "tt12412888",
    emojiText: "🦔👟✌️",
  },
  {
    id: "tt0088763",
    emojiText: "🚗🔙⌚👨‍🔬🙍",
  },
  {
    id: "tt0435761",
    emojiText: "👨‍🚀🤠🏫🍓🧸",
  },
  {
    id: "tt0116629",
    emojiText: "🇺🇸🎆👽👊",
  },
  {
    id: "tt0325980",
    emojiText: "🏴‍☠️🌊💀⚔️⚫📿",
  },
  {
    id: "tt6467266",
    emojiText: "🐷🦍🦁🎹🎧🦔",
  },
  {
    id: "tt1160419",
    emojiText: "👩‍👦🗡️⏳🐛🪐",
  },
  {
    id: "tt0066921",
    emojiText: "👁️🎩🦯🥛🍊",
  },
  {
    id: "tt1049413",
    emojiText: "👴🧒🎈🏠🏞️🐕🔼",
  },
  {
    id: "tt0120338",
    emojiText: "💑🚢🧊🥶👵",
  },
  {
    id: "tt0050083",
    emojiText: "😠1️⃣2️⃣",
  },
  {
    id: "tt0073195",
    emojiText: "🦈😱",
  },
  {
    id: "tt0137523",
    emojiText: "🥊♣️🧼",
  },
  {
    id: "tt0088247",
    emojiText: "🤖🕶️🔫",
  },
  {
    id: "tt0110413",
    emojiText: "🧔🔫🥛👧",
  },
  {
    id: "tt0110912",
    emojiText: "💼🕺💉💃☕⌚",
  },
  {
    id: "tt0083658",
    emojiText: "🗡️🏃‍♂️",
  },
  {
    id: "tt4729430",
    emojiText: "📫🧓🔨🧸🛷",
  },
  {
    id: "tt2382320",
    emojiText: "🚫🕐💀",
  },
  {
    id: "tt1201607",
    emojiText: "👦⚡☠️⚔️2️⃣",
  },
  {
    id: "tt0095016",
    emojiText: "🗼🎄👨🔫",
  },
  {
    id: "tt0041959",
    emojiText: "🧍‍♂️🧍‍♂️🧍‍♂️⬅️",
  },
  {
    id: "tt0070047",
    emojiText: "✝️🤮🙏",
  },
  {
    id: "tt0266697",
    emojiText: "👱‍♀️⛩️⚔️",
  },
  {
    id: "tt0081505",
    emojiText: "🪓😈🛀",
  },
  {
    id: "tt10298810",
    emojiText: "👨‍🚀🌌",
  },
  {
    id: "tt0167404",
    emojiText: "👁️👀💀🧑‍🤝‍🧑",
  },
  {
    id: "tt9032400",
    emojiText: "🦸‍♂️🌍♾️",
  },
  {
    id: "tt0317705",
    emojiText: "👨‍👩‍👧‍👦🦸ℹ️",
  },
  {
    id: "tt6751668",
    emojiText: "👨‍👩‍👧‍👦💸🇰🇷",
  },
  {
    id: "tt0266543",
    emojiText: "🔎🐟",
  },
  {
    id: "tt0075148",
    emojiText: "🥊",
  },
  {
    id: "tt0112573",
    emojiText: "🏴󠁧󠁢󠁳󠁣󠁴󠁿⚔️😠☠️",
  },
  {
    id: "tt0816692",
    emojiText: "🚀🌊⏲️🌽",
  },
  {
    id: "tt0102926",
    emojiText: "🤐🐑",
  },
  {
    id: "tt0884328",
    emojiText: "🌫️🛒🌫️",
  },
  {
    id: "tt1375666",
    emojiText: "💤🌀⤴️",
  },
  {
    id: "tt0060196",
    emojiText: "👍👎👹",
  },
  {
    id: "tt0198781",
    emojiText: "🟢👁️🟢👧👹",
  },
  {
    id: "tt0892769",
    emojiText: "⚫🐉🦷",
  },
  {
    id: "tt0910970",
    emojiText: "🌍🗑️🤖🌱❤️",
  },
  {
    id: "tt8503618",
    emojiText: "🇺🇸🎼🗽🎵🔫",
  },
  {
    id: "tt0457430",
    emojiText: "👁️👐👁️",
  },
  {
    id: "tt0118715",
    emojiText: "🎳🥛💼🩲",
  },
  {
    id: "tt0169547",
    emojiText: "🇺🇸💅🌹🌹🌹🌹🌹🌹",
  },
  {
    id: "tt0056172",
    emojiText: "🏇🏜️🗡️",
  },
  {
    id: "tt1345836",
    emojiText: "🦇🤵⬆️",
  },
  {
    id: "tt0102926",
    emojiText: "🔇🐏",
  },
  {
    id: "tt1375666",
    emojiText: "💡➡😴",
  },
  {
    id: "tt0114709",
    emojiText: "🥔🤠👨‍🚀🐊🐖🐶",
  },
  {
    id: "tt0167260",
    emojiText: "💍🌋🧙‍♂️👑",
  },
  {
    id: "tt6139732",
    emojiText: "🧞‍♂️🪔🐒👸🤴",
  },
  {
    id: "tt0211915",
    emojiText: "👩‍🦰🎠🗼🥖🇫🇷",
  },
  {
    id: "tt1745960",
    emojiText: "✈️🇺🇸🕶️",
  },
  {
    id: "tt0109830",
    emojiText: "🏃🍫🦐",
  },
  {
    id: "tt0120382",
    emojiText: "🙍‍♂️🎥⛵😨📺",
  },
  {
    id: "tt4633694",
    emojiText: "🕷️🦸🦹🦸‍♂️🦹‍♂️🦸‍♀️🦹‍♀️🎨✏️",
  },
  {
    id: "tt0090605",
    emojiText: "👽🤰🩸😱",
  },
  {
    id: "tt0062622",
    emojiText: "👁️🖥️🛰️🚀",
  },
  {
    id: "tt0054215",
    emojiText: "🔪🚿🧓",
  },
  {
    id: "tt0101414",
    emojiText: "🌹👸🧌",
  },
  {
    id: "tt0264464",
    emojiText: "🏃‍♂️✈️💰🏃",
  },
  {
    id: "tt0045152",
    emojiText: "☔🎤😃",
  },
  {
    id: "tt0107290",
    emojiText: "🦟💉🥚🦕🦖🚨🏃‍♂️",
  },
  {
    id: "tt0382932",
    emojiText: "🐭💆‍♂️👨‍🍳🍲",
  },
  {
    id: "tt10648342",
    emojiText: "🦸🔨❤️➕⛈️",
  },
  {
    id: "tt0482571",
    emojiText: "🏃🚪🎩🚪🏃▶️👬",
  },
  {
    id: "tt2380307",
    emojiText: "🎸💀👦🇲🇽",
  },
  {
    id: "tt0107048",
    emojiText: "🔄⏰🦔",
  },
  {
    id: "tt0133093",
    emojiText: "🕵️🕵️‍♀️🤜🤵🔌💊",
  },
  {
    id: "tt1130884",
    emojiText: "👮‍♂️💊🏝️😨",
  },
  {
    id: "tt0114369",
    emojiText: "😋😛😴🤢😡😎🤤👀",
  },
  {
    id: "tt5311514",
    emojiText: "👦💬⁉️↔️⁉️🗨️👧🗾🌊☄️",
  },
  {
    id: "tt0119217",
    emojiText: "🧹🏫👨‍🏫🧠🍎",
  },
  {
    id: "tt12412888",
    emojiText: "🦔👟✌️",
  },
  {
    id: "tt0088763",
    emojiText: "🚗🔙⌚👨‍🔬🙍",
  },
  {
    id: "tt0435761",
    emojiText: "👨‍🚀🤠🏫🍓🧸",
  },
  {
    id: "tt0116629",
    emojiText: "🇺🇸🎆👽👊",
  },
  {
    id: "tt0325980",
    emojiText: "🏴‍☠️🌊💀⚔️⚫📿",
  },
  {
    id: "tt6467266",
    emojiText: "🐷🦍🦁🎹🎧🦔",
  },
  {
    id: "tt1160419",
    emojiText: "👩‍👦🗡️⏳🐛🪐",
  },
  {
    id: "tt0066921",
    emojiText: "👁️🎩🦯🥛🍊",
  },
  {
    id: "tt1049413",
    emojiText: "👴🧒🎈🏠🏞️🐕🔼",
  },
  {
    id: "tt0120338",
    emojiText: "💑🚢🧊🥶👵",
  },
  {
    id: "tt0050083",
    emojiText: "😠1️⃣2️⃣",
  },
  {
    id: "tt0073195",
    emojiText: "🦈😱",
  },
  {
    id: "tt0137523",
    emojiText: "🥊♣️🧼",
  },
  {
    id: "tt0088247",
    emojiText: "🤖🕶️🔫",
  },
  {
    id: "tt0110413",
    emojiText: "🧔🔫🥛👧",
  },
  {
    id: "tt0110912",
    emojiText: "💼🕺💉💃☕⌚",
  },
  {
    id: "tt0083658",
    emojiText: "🗡️🏃‍♂️",
  },
  {
    id: "tt4729430",
    emojiText: "📫🧓🔨🧸🛷",
  },
  {
    id: "tt2382320",
    emojiText: "🚫🕐💀",
  },
  {
    id: "tt1201607",
    emojiText: "👦⚡☠️⚔️2️⃣",
  },
  {
    id: "tt0095016",
    emojiText: "🗼🎄👨🔫",
  },
  {
    id: "tt0041959",
    emojiText: "🧍‍♂️🧍‍♂️🧍‍♂️⬅️",
  },
  {
    id: "tt0070047",
    emojiText: "✝️🤮🙏",
  },
  {
    id: "tt0266697",
    emojiText: "👱‍♀️⛩️⚔️",
  },
  {
    id: "tt0081505",
    emojiText: "🪓😈🛀",
  },
  {
    id: "tt10298810",
    emojiText: "👨‍🚀🌌",
  },
  {
    id: "tt0167404",
    emojiText: "👁️👀💀🧑‍🤝‍🧑",
  },
  {
    id: "tt9032400",
    emojiText: "🦸‍♂️🌍♾️",
  },
  {
    id: "tt0317705",
    emojiText: "👨‍👩‍👧‍👦🦸ℹ️",
  },
  {
    id: "tt6751668",
    emojiText: "👨‍👩‍👧‍👦💸🇰🇷",
  },
  {
    id: "tt0266543",
    emojiText: "🔎🐟",
  },
  {
    id: "tt0075148",
    emojiText: "🥊",
  },
  {
    id: "tt0112573",
    emojiText: "🏴󠁧󠁢󠁳󠁣󠁴󠁿⚔️😠☠️",
  },
  {
    id: "tt0816692",
    emojiText: "🚀🌊⏲️🌽",
  },
  {
    id: "tt0102926",
    emojiText: "🤐🐑",
  },
  {
    id: "tt0884328",
    emojiText: "🌫️🛒🌫️",
  },
  {
    id: "tt1375666",
    emojiText: "💤🌀⤴️",
  },
  {
    id: "tt0468569",
    emojiText: "🦸‍♂️🌃🃏🦇",
  },
  {
    id: "tt0071562",
    emojiText: "🕴️🇮🇹2️⃣🔫🐴",
  },
  {
    id: "tt0120737",
    emojiText: "💍🏔️🧝‍♂️🧙‍♂️🐉",
  },
  {
    id: "tt0167261",
    emojiText: "💍2️⃣🏞️🏰🔥",
  },
  {
    id: "tt0080684",
    emojiText: "🚀⭐⚔️❄️🤖",
  },
  {
    id: "tt0099685",
    emojiText: "🇮🇹🔫💵🍝👨‍👩‍👦‍👦",
  },
  {
    id: "tt0073486",
    emojiText: "🦅🛏️🏥🚁🏞️",
  },
  {
    id: "tt0047478",
    emojiText: "🇯🇵⚔️🌾🏰🌄",
  },
  {
    id: "tt0038650",
    emojiText: "🏡💕👼🎄💸",
  },
  {
    id: "tt0317248",
    emojiText: "🌆🇧🇷🔫🏚️",
  },
  {
    id: "tt0120815",
    emojiText: "🇺🇸🔫🔎👨‍🦱",
  },
  {
    id: "tt0118799",
    emojiText: "👨‍👦🇮🇹😄🌹",
  },
  {
    id: "tt0103064",
    emojiText: "🤖🔫2️⃣💥",
  },
  {
    id: "tt0407887",
    emojiText: "👮‍♂️🔫🐀🇮🇪",
  },
  {
    id: "tt1675434",
    emojiText: "🇫🇷👨‍🦽👨‍🦱🎵",
  },
  {
    id: "tt0027977",
    emojiText: "⚙️🏭🕰️😄",
  },
  {
    id: "tt0056058",
    emojiText: "🇯🇵🗡️🎎🏯",
  },
  {
    id: "tt0064116",
    emojiText: "🤠🏜️🚂🔫",
  },
  {
    id: "tt0047396",
    emojiText: "👀🔭🏢🚔",
  },
  {
    id: "tt0078748",
    emojiText: "👽🚀🏭🌌",
  },
  {
    id: "tt0095765",
    emojiText: "🎥🎞️🇮🇹💔",
  },
  {
    id: "tt0209144",
    emojiText: "⏮️🧩🔍📸",
  },
  {
    id: "tt0405094",
    emojiText: "🇩🇪👀🎧📝",
  },
  {
    id: "tt0043014",
    emojiText: "🌅🛣️🎥👩‍🦳",
  },
  {
    id: "tt0050825",
    emojiText: "🥾🏞️🎖️🇫🇷",
  },
  {
    id: "tt0032553",
    emojiText: "🌍🎩👨‍⚖️🎈",
  },
  {
    id: "tt0051201",
    emojiText: "🧐👩‍⚖️🕵️‍♂️📝",
  },
  {
    id: "tt0036775",
    emojiText: "🔄🔍💰👫",
  },
  {
    id: "tt0053604",
    emojiText: "🏢💘👨‍💼",
  },
  {
    id: "tt0086250",
    emojiText: "👨💊🔫🏙️",
  },
  {
    id: "tt0044741",
    emojiText: "👨🏻‍💼⏳🎢",
  },
  {
    id: "tt0070735",
    emojiText: "🎩💰🃏",
  },
  {
    id: "tt0056592",
    emojiText: "🕊️⚖️👧👦",
  },
  {
    id: "tt0119488",
    emojiText: "🔎🚔🚬🌆",
  },
  {
    id: "tt1832382",
    emojiText: "👫🏻💔🇮🇷",
  },
  {
    id: "tt0208092",
    emojiText: "💎🥊🐷",
  },
  {
    id: "tt1255953",
    emojiText: "🔥👩‍👧‍👦📜",
  },
  {
    id: "tt0097576",
    emojiText: "🤠🏺✝️",
  },
  {
    id: "tt0040522",
    emojiText: "🚲❌👨‍👦",
  },
  {
    id: "tt8579674",
    emojiText: "🌍⏳🔫🕊️1️⃣7️⃣",
  },
  {
    id: "tt0986264",
    emojiText: "👦📚🌟",
  },
  {
    id: "tt0363163",
    emojiText: "🇩🇪👨‍✈️⬇️",
  },
  {
    id: "tt10872600",
    emojiText: "🕷️👦🚫🏠",
  },
  {
    id: "tt0059578",
    emojiText: "💰💰🔫",
  },
  {
    id: "tt0372784",
    emojiText: "🦇👦🏙️",
  },
  {
    id: "tt5074352",
    emojiText: "🤼‍♀️🏅🇮🇳",
  },
  {
    id: "tt0012349",
    emojiText: "🧒🎩👫",
  },
  {
    id: "tt10272386",
    emojiText: "👴🧠🔄",
  },
  {
    id: "tt0042192",
    emojiText: "🎭👩🔝",
  },
  {
    id: "tt6966692",
    emojiText: "🚗🎵📗",
  },
  {
    id: "tt0055031",
    emojiText: "⚖️🇩🇪🕰️",
  },
  {
    id: "tt0042876",
    emojiText: "🌳🔪🎌🎭",
  },
  {
    id: "tt0477348",
    emojiText: "🏜️💼💰🔫",
  },
  {
    id: "tt0080678",
    emojiText: "🎩🐘😭💔",
  },
  {
    id: "tt0071315",
    emojiText: "🕵️🏙️💔🔪",
  },
  {
    id: "tt0031381",
    emojiText: "👩💔🌪️🏡",
  },
  {
    id: "tt0434409",
    emojiText: "✌️🎭💣🇬🇧",
  },
  {
    id: "tt0084787",
    emojiText: "❄️👾😱🔥",
  },
  {
    id: "tt0120735",
    emojiText: "🔒💼🔫💰",
  },
  {
    id: "tt0046912",
    emojiText: "☎️🔪😱🕵️",
  },
  {
    id: "tt1305806",
    emojiText: "👁️🔍💔⏳",
  },
  {
    id: "tt0050212",
    emojiText: "🌉🏞️⛓️💣",
  },
  {
    id: "tt0347149",
    emojiText: "🧙‍♂️🏰🔮🐺",
  },
  {
    id: "tt5027774",
    emojiText: "3️⃣🛑🔥💔",
  },
  {
    id: "tt1205489",
    emojiText: "🚗👴🔫🏠",
  },
  {
    id: "tt1291584",
    emojiText: "🤼‍♂️🥊👨‍👦‍👦🏆",
  },
  {
    id: "tt0116282",
    emojiText: "❄️🚗💵🔫",
  },
  {
    id: "tt1392214",
    emojiText: "👭🚐👮‍♂️🔍",
  },
  {
    id: "tt0405159",
    emojiText: "🥊💵🏆👧",
  },
  {
    id: "tt0015864",
    emojiText: "⛏️🏔️🤑🍞",
  },
  {
    id: "tt0047296",
    emojiText: "🚢⚓️🥊🐦",
  },
  {
    id: "tt0118849",
    emojiText: "🧒👟🏃‍♂️🏅",
  },
  {
    id: "tt0052618",
    emojiText: "👑🐎🛡️⛓️",
  },
  {
    id: "tt0017925",
    emojiText: "🚂👨‍✈️💣💔",
  },
  {
    id: "tt0112471",
    emojiText: "👫🌇💬❤️",
  },
  {
    id: "tt0050986",
    emojiText: "🍓👴🚗💭",
  },
  {
    id: "tt2267998",
    emojiText: "👩💍💌🔪",
  },
  {
    id: "tt0077416",
    emojiText: "🦌🏹🔫🇻🇳",
  },
  {
    id: "tt0107207",
    emojiText: "👨‍👦💣⚖️🇬🇧",
  },
  {
    id: "tt3011894",
    emojiText: "🦊📖💥💔",
  },
  {
    id: "tt1392190",
    emojiText: "😡🚗💥🏜️",
  },
  {
    id: "tt0978762",
    emojiText: "👧💌👴🇦🇺",
  },
  {
    id: "tt0019254",
    emojiText: "👩‍🌾🙏🔥⛪",
  },
  {
    id: "tt0097165",
    emojiText: "👨‍🏫📚💭🕊️",
  },
  {
    id: "tt0395169",
    emojiText: "🏨🇷🇼👨‍👩‍👧‍👦🔫",
  },
  {
    id: "tt0046438",
    emojiText: "👵👴🌆🎌",
  },
  {
    id: "tt0048473",
    emojiText: "👨‍👩‍👧‍👦🏞️🇮🇳💔",
  },
  {
    id: "tt0091763",
    emojiText: "👨‍👦‍👦🔫🌴🇻🇳",
  },
  {
    id: "tt1950186",
    emojiText: "🚘⚙️🏁🏆",
  },
  {
    id: "tt0092005",
    emojiText: "👦👦👦👦🛤️👑",
  },
  {
    id: "tt1895587",
    emojiText: "🔍📰⛪👥",
  },
  {
    id: "tt1979320",
    emojiText: "🏎️💨⏱️🏆",
  },
  {
    id: "tt0074958",
    emojiText: "📺💬🏙️🎭",
  },
  {
    id: "tt0758758",
    emojiText: "🚶‍♂️🌲🚌🌄",
  },
  {
    id: "tt3315342",
    emojiText: "👨🔪🚗👧",
  },
  {
    id: "tt0381681",
    emojiText: "💑🌅🇫🇷💬",
  },
  {
    id: "tt0036868",
    emojiText: "🇺🇸🎖️👨‍👩‍👧‍👦❤️",
  },
  {
    id: "tt0032976",
    emojiText: "👰🏰🔥💔",
  },
  {
    id: "tt0058946",
    emojiText: "🇩🇿💣🔫🏙️",
  },
  {
    id: "tt0032551",
    emojiText: "🍇😡👨‍👩‍👧‍👦🚚",
  },
  {
    id: "tt0061512",
    emojiText: "😎✋👷🥚",
  },
  {
    id: "tt0245712",
    emojiText: "🐶❤️🚗💥",
  },
  {
    id: "tt0113247",
    emojiText: "👨‍👨‍👦🏙️🔫💔",
  },
  {
    id: "tt0053198",
    emojiText: "👦💔🏃‍♂️🇫🇷",
  },
  {
    id: "tt0060827",
    emojiText: "👩‍⚕️👩🎭🏖️",
  },
  {
    id: "tt0476735",
    emojiText: "👨👦❤️💔",
  },
  {
    id: "tt0079470",
    emojiText: "👨‍🦱🙌✨😂",
  },
  {
    id: "tt0025316",
    emojiText: "🌃👫🚌💘",
  },
  {
    id: "tt0059742",
    emojiText: "🎵🏞️👩‍👧‍👦🇦🇹",
  },
  {
    id: "tt0071411",
    emojiText: "🧑🏔️🌲🇷🇺",
  },
  {
    id: "tt4016934",
    emojiText: "👩‍❤️‍👩📘🇰🇷🏰",
  },
  {
    id: "tt15097216",
    emojiText: "⚖️🇮🇳💼🗣️",
  },
  {
    id: "tt0083987",
    emojiText: "🇮🇳👳‍♂️☮️📚",
  },
  {
    id: "tt1454029",
    emojiText: "👩‍🦰📚👩‍🦱🥧",
  },
  {
    id: "tt3704428",
    emojiText: "🕺🎤🎸🇺🇸",
  },
  {
    id: "tt5113044",
    emojiText: "🍌🦹‍♂️🏢🌆",
  },
  {
    id: "tt10304142",
    emojiText: "🚲🌷🇳🇱🏛️",
  },
  {
    id: "tt9419884",
    emojiText: "🧙‍♂️💫🌀🌌",
  },
  {
    id: "tt7144666",
    emojiText: "📞⚫🕵️‍♂️👦",
  },
  {
    id: "tt8041270",
    emojiText: "🦖🌍🏰🦕",
  },
  {
    id: "tt4123432",
    emojiText: "🔮🐉🧙📜",
  },
  {
    id: "tt21059520",
    emojiText: "👧🖼️📷🔍",
  },
  {
    id: "tt13841850",
    emojiText: "👨👨‍🦱👨‍🦳🕴️",
  },
  {
    id: "tt8093700",
    emojiText: "👩👑⚔️🏰",
  },
  {
    id: "tt7131622",
    emojiText: "🎬🌟🌴💫",
  },
  {
    id: "tt13320622",
    emojiText: "🗺️🏙️🔍🕵️‍♂️",
  },
  {
    id: "tt12593682",
    emojiText: "🚄🔫💥🎯",
  },
  {
    id: "tt14549466",
    emojiText: "🔮🚀🔬⚖️",
  },
  {
    id: "tt5108870",
    emojiText: "🩸🦇🔬🧛‍♂️",
  },
  {
    id: "tt1649418",
    emojiText: "👤🔫🕵️‍♂️💼",
  },
  {
    id: "tt11128440",
    emojiText: "👔💼🛍️🗣️",
  },
  {
    id: "tt8178634",
    emojiText: "🇮🇳🔥⚔️🛤️",
  },
  {
    id: "tt9851854",
    emojiText: "👮‍♂️🎖️🇮🇳🔫",
  },
  {
    id: "tt2231253",
    emojiText: "🃏🎲🔫💰",
  },
  {
    id: "tt4998632",
    emojiText: "🚑🚨🏥🚔",
  },
  {
    id: "tt1323594",
    emojiText: "😈👧👧👧🍌",
  },
  {
    id: "tt14376344",
    emojiText: "💃🕺🎶🎈",
  },
  {
    id: "tt8323668",
    emojiText: "👴👵💰🎰",
  },
  {
    id: "tt0089218",
    emojiText: "🏴‍☠️🗺️💎👦",
  },
  {
    id: "tt4181158",
    emojiText: "👋👋💔💌",
  },
  {
    id: "tt1981115",
    emojiText: "🔨⚡🌌👑",
  },
  {
    id: "tt14145426",
    emojiText: "👦👦🚀🌌",
  },
  {
    id: "tt0134119",
    emojiText: "🎩🔎💼🔪",
  },
  {
    id: "tt1879016",
    emojiText: "💼🕵️‍♂️📜🕹️",
  },
  {
    id: "tt10954652",
    emojiText: "👵🏝️⏳👴",
  },
  {
    id: "tt12545566",
    emojiText: "📜🎩💕💌",
  },
  {
    id: "tt0114709",
    emojiText: "🥔🤠👨‍🚀🐊🐖🐶",
  },
  {
    id: "tt0167260",
    emojiText: "💍🌋🧙‍♂️👑",
  },
  {
    id: "tt0103639",
    emojiText: "🧞‍♂️🪔🐒👸🤴",
  },
  {
    id: "tt0211915",
    emojiText: "👩‍🦰🎠🗼🥖🇫🇷",
  },
  {
    id: "tt1745960",
    emojiText: "✈️🇺🇸🕶️",
  },
  {
    id: "tt0109830",
    emojiText: "🏃🍫🦐",
  },
  {
    id: "tt0120382",
    emojiText: "🙍‍♂️🎥⛵😨📺",
  },
  {
    id: "tt4633694",
    emojiText: "🕷️🦸🦹🦸‍♂️🦹‍♂️🦸‍♀️🦹‍♀️🎨✏️",
  },
  {
    id: "tt0090605",
    emojiText: "👽🤰🩸😱",
  },
  {
    id: "tt0062622",
    emojiText: "👁️🖥️🛰️🚀",
  },
  {
    id: "tt0054215",
    emojiText: "🔪🚿🧓",
  },
  {
    id: "tt0101414",
    emojiText: "🌹👸🧌",
  },
  {
    id: "tt0264464",
    emojiText: "🏃‍♂️✈️💰🏃",
  },
  {
    id: "tt0045152",
    emojiText: "☔🎤😃",
  },
  {
    id: "tt0107290",
    emojiText: "🦟💉🥚🦕🦖🚨🏃‍♂️",
  },
  {
    id: "tt0993846",
    emojiText: "🐺🧱🛣️〽️🏦💵",
  },
  {
    id: "tt0382932",
    emojiText: "🐭💆‍♂️👨‍🍳🍲",
  },
  {
    id: "tt10648342",
    emojiText: "🦸🔨❤️➕⛈️",
  },
  {
    id: "tt0482571",
    emojiText: "🏃🚪🎩🚪🏃▶️👬",
  },
  {
    id: "tt2380307",
    emojiText: "🎸💀👦🇲🇽",
  },
  {
    id: "tt0107048",
    emojiText: "🔄⏰🦔",
  },
  {
    id: "tt0133093",
    emojiText: "🕵️🕵️‍♀️🤜🤵🔌💊",
  },
  {
    id: "tt1130884",
    emojiText: "👮‍♂️💊🏝️😨",
  },
  {
    id: "tt2293640",
    emojiText: "🤓🤓🤓🍌🧒",
  },
  {
    id: "tt0114369",
    emojiText: "😋😛😴🤢😡😎🤤👀",
  },
  {
    id: "tt5311514",
    emojiText: "👦💬⁉️↔️⁉️🗨️👧🗾🌊☄️",
  },
  {
    id: "tt0119217",
    emojiText: "🧹🏫👨‍🏫🧠🍎",
  },
  {
    id: "tt12412888",
    emojiText: "🦔👟✌️",
  },
  {
    id: "tt0088763",
    emojiText: "🚗🔙⌚👨‍🔬🙍",
  },
  {
    id: "tt0435761",
    emojiText: "👨‍🚀🤠🏫🍓🧸",
  },
  {
    id: "tt0116629",
    emojiText: "🇺🇸🎆👽👊",
  },
  {
    id: "tt0325980",
    emojiText: "🏴‍☠️🌊💀⚔️⚫📿",
  },
  {
    id: "tt6467266",
    emojiText: "🐷🦍🦁🎹🎧🦔",
  },
  {
    id: "tt1160419",
    emojiText: "👩‍👦🗡️⏳🐛🪐",
  },
  {
    id: "tt0066921",
    emojiText: "👁️🎩🦯🥛🍊",
  },
  {
    id: "tt1049413",
    emojiText: "👴🧒🎈🏠🏞️🐕🔼",
  },
  {
    id: "tt2582802",
    emojiText: "🥁👨‍🦲⏱️🩸🚗📁🎶",
  },
  {
    id: "tt0120338",
    emojiText: "💑🚢🧊🥶👵",
  },
  {
    id: "tt2096673",
    emojiText: "😡😭😊🤢😱🧠",
  },
  {
    id: "tt0050083",
    emojiText: "😠1️⃣2️⃣",
  },
  {
    id: "tt1396484",
    emojiText: "🤡👿🎈",
  },
  {
    id: "tt0073195",
    emojiText: "🦈😱",
  },
  {
    id: "tt0137523",
    emojiText: "🥊♣️🧼",
  },
  {
    id: "tt1877830",
    emojiText: "🦇🐱🐧❓",
  },
  {
    id: "tt0088247",
    emojiText: "🤖🕶️🔫",
  },
  {
    id: "tt0110413",
    emojiText: "🧔🔫🥛👧",
  },
  {
    id: "tt0110912",
    emojiText: "💼🕺💉💃☕⌚",
  },
  {
    id: "tt0083658",
    emojiText: "🗡️🏃‍♂️",
  },
  {
    id: "tt4729430",
    emojiText: "📫🧓🔨🧸🛷",
  },
  {
    id: "tt2382320",
    emojiText: "🚫🕐💀",
  },
  {
    id: "tt1201607",
    emojiText: "👦⚡☠️⚔️2️⃣",
  },
  {
    id: "tt2024544",
    emojiText: "🕛🗓️⛓️",
  },
  {
    id: "tt0095016",
    emojiText: "🗼🎄👨🔫",
  },
  {
    id: "tt0041959",
    emojiText: "🧍‍♂️🧍‍♂️🧍‍♂️⬅️",
  },
  {
    id: "tt0070047",
    emojiText: "✝️🤮🙏",
  },
  {
    id: "tt0266697",
    emojiText: "👱‍♀️⛩️⚔️",
  },
  {
    id: "tt0081505",
    emojiText: "🪓😈🛀",
  },
  {
    id: "tt10298810",
    emojiText: "👨‍🚀🌌",
  },
  {
    id: "tt0167404",
    emojiText: "👁️👀💀🧑‍🤝‍🧑",
  },
  {
    id: "tt9032400",
    emojiText: "🦸‍♂️🌍♾️",
  },
  {
    id: "tt0317705",
    emojiText: "👨‍👩‍👧‍👦🦸ℹ️",
  },
  {
    id: "tt6751668",
    emojiText: "👨‍👩‍👧‍👦💸🇰🇷",
  },
  {
    id: "tt0266543",
    emojiText: "🔎🐟",
  },
  {
    id: "tt4154756",
    emojiText: "♾️⚔️",
  },
  {
    id: "tt0075148",
    emojiText: "🥊",
  },
  {
    id: "tt0112573",
    emojiText: "🏴󠁧󠁢󠁳󠁣󠁴󠁿⚔️😠☠️",
  },
  {
    id: "tt0816692",
    emojiText: "🚀🌊⏲️🌽",
  },
  {
    id: "tt0102926",
    emojiText: "🤐🐑",
  },
  {
    id: "tt0032138",
    emojiText: "🐶👠👠🌪️🏠",
  },
  {
    id: "tt0884328",
    emojiText: "🌫️🛒🌫️",
  },
  {
    id: "tt1375666",
    emojiText: "💤🌀⤴️",
  },
  {
    id: "tt0060196",
    emojiText: "👍👎👹",
  },
  {
    id: "tt0198781",
    emojiText: "🟢👁️🟢👧👹",
  },
  {
    id: "tt0892769",
    emojiText: "⚫🐉🦷",
  },
  {
    id: "tt0910970",
    emojiText: "🌍🗑️🤖🌱❤️",
  },
  {
    id: "tt8503618",
    emojiText: "🇺🇸🎼🗽🎵🔫",
  },
  {
    id: "tt0457430",
    emojiText: "👁️👐👁️",
  },
  {
    id: "tt0118715",
    emojiText: "🎳🥛💼🩲",
  },
  {
    id: "tt0169547",
    emojiText: "🇺🇸💅🌹🌹🌹🌹🌹🌹",
  },
  {
    id: "tt0056172",
    emojiText: "🏇🏜️🗡️",
  },
  {
    id: "tt1345836",
    emojiText: "🦇🤵⬆️",
  },
  {
    id: "tt0102926",
    emojiText: "🔇🐏",
  },
  {
    id: "tt0034583",
    emojiText: "🇫🇷💖🚂😒🕌☕🎹✈️",
  },
  {
    id: "tt1028532",
    emojiText: "🐶🙍‍♂️🚋⏱️",
  },
  {
    id: "tt0119698",
    emojiText: "🐺👸🩸🐗🐛",
  },
  {
    id: "tt0090605",
    emojiText: "🌐👩👧🐱💥👽",
  },
  {
    id: "tt0053291",
    emojiText: "👨‍🦰👨‍🦱👠💄👗",
  },
  {
    id: "tt0110357",
    emojiText: "🦁🐆🐗👑",
  },
  {
    id: "tt0245429",
    emojiText: "🐉😱👹👵⛩️",
  },
  {
    id: "tt0117951",
    emojiText: "💉👬🧑‍🤝‍🧑💊🇬🇧🤪🤮",
  },
  {
    id: "tt7657566",
    emojiText: "👨🔎🇪🇬⛴️☠️",
  },
  {
    id: "tt0096283",
    emojiText: "▶️🚪🏠🐻",
  },
  {
    id: "tt4513678",
    emojiText: "🙍🙍🙍🙍👻🧹",
  },
  {
    id: "tt1464335",
    emojiText: "🗺️🧗‍♂️🚁💰",
  },
  {
    id: "tt0338013",
    emojiText: "💑💔😭💵👨‍🔬😴🧠💻🕵️🙂",
  },
  {
    id: "tt0068646",
    emojiText: "🐴🛏️🩸",
  },
  {
    id: "tt0082971",
    emojiText: "🏜️🕌💼💀🤠",
  },
  {
    id: "tt6264654",
    emojiText: "🎮🔫🧑‍💻⌨️🏦",
  },
  {
    id: "tt0017136",
    emojiText: "🤖🌆🇩🇪🎥",
  },
  {
    id: "tt0120689",
    emojiText: "💀🚶‍♂️🟩🟩🟩",
  },
  {
    id: "tt0111161",
    emojiText: "👨‍⚖️😧♟️⛏️👋",
  },
  {
    id: "tt0172495",
    emojiText: "🤼‍♂️🏟️⚔️👎",
  },
  {
    id: "tt1201607",
    emojiText: "👦⚡🔺💫🚫👃☠️",
  },
  {
    id: "tt8772262",
    emojiText: "💐🔪🐻",
  },
  {
    id: "tt1853728",
    emojiText: "🦷🤠🧐🏇⛓️",
  },
  {
    id: "tt0114814",
    emojiText: "👮‍♂️🤬🔫🕵️‍♂️❔",
  },
  {
    id: "tt0095327",
    emojiText: "👨‍👧⚰️🌌🌂🇯🇵",
  },
  {
    id: "tt0053198",
    emojiText: "👦💔🏃‍♂️🇫🇷",
  },
  {
    id: "tt7286456",
    emojiText: "🔫🤡🃏",
  },
  {
    id: "tt0253474",
    emojiText: "🧑🎹",
  },
  {
    id: "tt11703710",
    emojiText: "🎩👒📽️🎙️🇬🇧",
  },
  {
    id: "tt0057115",
    emojiText: "🇩🇪🕳️⛏️🏍️🚞",
  },
  {
    id: "tt1130884",
    emojiText: "🏝️🧐🏨",
  },
  {
    id: "tt0100157",
    emojiText: "⌨️👩‍🦼🔨👩‍🦰",
  },
  {
    id: "tt15521050",
    emojiText: "❤️🍦",
  },
  {
    id: "tt0076759",
    emojiText: "⭐🔫💣",
  },
  {
    id: "tt0081398",
    emojiText: "😡🐂",
  },
  {
    id: "tt0092099",
    emojiText: "🔝🔫🛩",
  },
  {
    id: "tt0105236",
    emojiText: "🚧🌊🚧🐶",
  },
  {
    id: "tt1050263",
    emojiText: "❄◽",
  },
  {
    id: "tt0106965",
    emojiText: "🆓🐳",
  },
  {
    id: "tt0397892",
    emojiText: "🐶⚡",
  },
  {
    id: "tt11245972",
    emojiText: "😱🔪",
  },
  {
    id: "tt0118571",
    emojiText: "🛩🇺🇸1",
  },
  {
    id: "tt0119654",
    emojiText: "👨🏻⤵⬛👽",
  },
  {
    id: "tt0119695",
    emojiText: "💰👄",
  },
  {
    id: "tt0120632",
    emojiText: "🏙👼🏻👼🏻",
  },
  {
    id: "tt0120812",
    emojiText: "🚗💨🕑",
  },
  {
    id: "tt0250494",
    emojiText: "⚖👩🏼👛🎥",
  },
  {
    id: "tt0375679",
    emojiText: "🚙💥🚗",
  },
  {
    id: "tt0437405",
    emojiText: "📄👨🏻",
  },
  {
    id: "tt0417217",
    emojiText: "2➡💰",
  },
  {
    id: "tt0112431",
    emojiText: "🐷💬🎥",
  },
  {
    id: "tt0086034",
    emojiText: "🐙🐱",
  },
  {
    id: "tt6139732",
    emojiText: "👳🏻🔮🌙",
  },
  {
    id: "tt0053285",
    emojiText: "💤👩🏻",
  },
  {
    id: "tt0096244",
    emojiText: "🍹🌄",
  },
  {
    id: "tt0097239",
    emojiText: "🚘👵🏻🌼",
  },
  {
    id: "tt0253474",
    emojiText: "👨🏻🎹",
  },
  {
    id: "tt9347730",
    emojiText: "🍬👨🏻",
  },
  {
    id: "tt0061852",
    emojiText: "🌴📖",
  },
  {
    id: "tt0111257",
    emojiText: "💣🚌💨💨",
  },
  {
    id: "tt0113117",
    emojiText: "🇫🇷💋",
  },
  {
    id: "tt0039536",
    emojiText: "💋💀",
  },
  {
    id: "tt0050083",
    emojiText: "12😡👨🏻",
  },
  {
    id: "tt1602620",
    emojiText: "👴🏻❤👵🏻",
  },
  {
    id: "tt0133152",
    emojiText: "🌍🐵🐵🐵",
  },
  {
    id: "tt0120338",
    emojiText: "🛳🌊💥",
  },
  {
    id: "tt0157503",
    emojiText: "💧💀👸🏻✨",
  },
  {
    id: "tt0161081",
    emojiText: "❓🛌🏻⬇",
  },
  {
    id: "tt0163187",
    emojiText: "🏃🏻👰🏻",
  },
  {
    id: "tt0175142",
    emojiText: "😱🎬",
  },
  {
    id: "tt0448694",
    emojiText: "😺👢",
  },
  {
    id: "tt4593060",
    emojiText: "👃🏻➡➡➡",
  },
  {
    id: "tt0044706",
    emojiText: "⬆🕛",
  },
  {
    id: "tt0250687",
    emojiText: "🐭🏃🏻🏃🏻🏃🏻",
  },
  {
    id: "tt0259324",
    emojiText: "👻👨🏻🐎",
  },
  {
    id: "tt0259711",
    emojiText: "🍦⛅",
  },
  {
    id: "tt0265086",
    emojiText: "⬛🐦⬇",
  },
  {
    id: "tt1210819",
    emojiText: "1👨🏻🐴",
  },
  {
    id: "tt0960731",
    emojiText: "😴📖",
  },
  {
    id: "tt0358273",
    emojiText: "🚶🏻➡➖➖",
  },
  {
    id: "tt0360717",
    emojiText: "👑🐵😡🏬",
  },
  {
    id: "tt0366548",
    emojiText: "😃👣",
  },
  {
    id: "tt0371746",
    emojiText: "ࠦ👨🏻",
  },
  {
    id: "tt0377471",
    emojiText: "🐝🆒",
  },
  {
    id: "tt0389790",
    emojiText: "🐝🎬",
  },
  {
    id: "tt0396269",
    emojiText: "👰🏻🤵🏻💥💥",
  },
  {
    id: "tt0401792",
    emojiText: "😈😈😈🌇",
  },
  {
    id: "tt0409459",
    emojiText: "⌚👨🏽👨🏽",
  },
  {
    id: "tt0415778",
    emojiText: "🔚🎮",
  },
  {
    id: "tt0417148",
    emojiText: "🐍🐍🛩",
  },
  {
    id: "tt0441773",
    emojiText: "👊🏻💥🐼",
  },
  {
    id: "tt0448157",
    emojiText: "🖐🏻🐓",
  },
  {
    id: "tt0450259",
    emojiText: "💉💎",
  },
  {
    id: "tt0454876",
    emojiText: "👳🏻🚣🏻♂🐅",
  },
  {
    id: "tt0472181",
    emojiText: "🔵👴🏻👧🏻👦🏻",
  },
  {
    id: "tt0499549",
    emojiText: "🔵👽",
  },
  {
    id: "tt0800369",
    emojiText: "⚡🔨💪🏻",
  },
  {
    id: "tt0879870",
    emojiText: "🍜🙏🏻❤",
  },
  {
    id: "tt0942385",
    emojiText: "🌴🍹⚡☔",
  },
  {
    id: "tt0961097",
    emojiText: "👹➡🇫🇷🗼",
  },
  {
    id: "tt0978621",
    emojiText: "🏃🏻💥⬅🚂",
  },
  {
    id: "tt1605783",
    emojiText: "🌃🕛🇫🇷🗼",
  },
  {
    id: "tt1074638",
    emojiText: "⛅🍃",
  },
  {
    id: "tt2103264",
    emojiText: "👑🇨🇳",
  },
  {
    id: "tt1276104",
    emojiText: "👨🏻🔫👦🏻🔄",
  },
  {
    id: "tt1289401",
    emojiText: "👻👻🔫",
  },
  {
    id: "tt1416801",
    emojiText: "🔫➡🍀👨🏻",
  },
  {
    id: "tt1424381",
    emojiText: "🐆🐅🐊",
  },
  {
    id: "tt14403842",
    emojiText: "🔟☔",
  },
  {
    id: "tt1860353",
    emojiText: "🐌💨",
  },
  {
    id: "tt1637725",
    emojiText: "🐻❤🍻🚬",
  },
  {
    id: "tt1790885",
    emojiText: "0🌌30",
  },
  {
    id: "tt1798709",
    emojiText: "👨🏻👓❤📱",
  },
  {
    id: "tt1885300",
    emojiText: "👌🏻👨🏻⬇",
  },
  {
    id: "tt0054215",
    emojiText: "🔪🚿",
  },
  {
    id: "tt1981677",
    emojiText: "🎤🎼💯",
  },
  {
    id: "tt0099785",
    emojiText: "🏠😱🎄👱🏻",
  },
  {
    id: "tt2334879",
    emojiText: "◽🏠⬇",
  },
  {
    id: "tt0021749",
    emojiText: "🏙💡💡",
  },
  {
    id: "tt0105236",
    emojiText: "🚧🌊🚧🐶",
  },
  {
    id: "tt1049413",
    emojiText: "🏠🎈🎈🎈",
  },
  {
    id: "tt0068646",
    emojiText: "🇮🇹😇👴🏻",
  },
  {
    id: "tt0109830",
    emojiText: "🏃🏻🍫🍤",
  },
  {
    id: "tt0137523",
    emojiText: "👊🏻♣",
  },
  {
    id: "tt0266543",
    emojiText: "🔎🐠",
  },
  {
    id: "tt1375666",
    emojiText: "💡➡😴",
  },
  {
    id: "tt0114709",
    emojiText: "🥔🤠👨‍🚀🐊🐖🐶",
  },
  {
    id: "tt0167260",
    emojiText: "💍🌋🧙‍♂️👑",
  },
  {
    id: "tt6139732",
    emojiText: "🧞‍♂️🪔🐒👸🤴",
  },
  {
    id: "tt0211915",
    emojiText: "👩‍🦰🎠🗼🥖🇫🇷",
  },
  {
    id: "tt1745960",
    emojiText: "✈️🇺🇸🕶️",
  },
  {
    id: "tt0109830",
    emojiText: "🏃🍫🦐",
  },
  {
    id: "tt0120382",
    emojiText: "🙍‍♂️🎥⛵😨📺",
  },
  {
    id: "tt4633694",
    emojiText: "🕷️🦸🦹🦸‍♂️🦹‍♂️🦸‍♀️🦹‍♀️🎨✏️",
  },
  {
    id: "tt0090605",
    emojiText: "👽🤰🩸😱",
  },
  {
    id: "tt0062622",
    emojiText: "👁️🖥️🛰️🚀",
  },
  {
    id: "tt0054215",
    emojiText: "🔪🚿🧓",
  },
  {
    id: "tt0101414",
    emojiText: "🌹👸🧌",
  },
  {
    id: "tt0264464",
    emojiText: "🏃‍♂️✈️💰🏃",
  },
  {
    id: "tt0045152",
    emojiText: "☔🎤😃",
  },
  {
    id: "tt0107290",
    emojiText: "🦟💉🥚🦕🦖🚨🏃‍♂️",
  },
  {
    id: "tt0382932",
    emojiText: "🐭💆‍♂️👨‍🍳🍲",
  },
  {
    id: "tt10648342",
    emojiText: "🦸🔨❤️➕⛈️",
  },
  {
    id: "tt0482571",
    emojiText: "🏃🚪🎩🚪🏃▶️👬",
  },
  {
    id: "tt2380307",
    emojiText: "🎸💀👦🇲🇽",
  },
  {
    id: "tt0107048",
    emojiText: "🔄⏰🦔",
  },
  {
    id: "tt0133093",
    emojiText: "🕵️🕵️‍♀️🤜🤵🔌💊",
  },
  {
    id: "tt1130884",
    emojiText: "👮‍♂️💊🏝️😨",
  },
  {
    id: "tt0114369",
    emojiText: "😋😛😴🤢😡😎🤤👀",
  },
  {
    id: "tt5311514",
    emojiText: "👦💬⁉️↔️⁉️🗨️👧🗾🌊☄️",
  },
  {
    id: "tt0119217",
    emojiText: "🧹🏫👨‍🏫🧠🍎",
  },
  {
    id: "tt12412888",
    emojiText: "🦔👟✌️",
  },
  {
    id: "tt0088763",
    emojiText: "🚗🔙⌚👨‍🔬🙍",
  },
  {
    id: "tt0435761",
    emojiText: "👨‍🚀🤠🏫🍓🧸",
  },
  {
    id: "tt0116629",
    emojiText: "🇺🇸🎆👽👊",
  },
  {
    id: "tt0325980",
    emojiText: "🏴‍☠️🌊💀⚔️⚫📿",
  },
  {
    id: "tt6467266",
    emojiText: "🐷🦍🦁🎹🎧🦔",
  },
  {
    id: "tt1160419",
    emojiText: "👩‍👦🗡️⏳🐛🪐",
  },
  {
    id: "tt0066921",
    emojiText: "👁️🎩🦯🥛🍊",
  },
  {
    id: "tt1049413",
    emojiText: "👴🧒🎈🏠🏞️🐕🔼",
  },
  {
    id: "tt0120338",
    emojiText: "💑🚢🧊🥶👵",
  },
  {
    id: "tt0050083",
    emojiText: "😠1️⃣2️⃣",
  },
  {
    id: "tt0073195",
    emojiText: "🦈😱",
  },
  {
    id: "tt0137523",
    emojiText: "🥊♣️🧼",
  },
  {
    id: "tt0088247",
    emojiText: "🤖🕶️🔫",
  },
  {
    id: "tt0110413",
    emojiText: "🧔🔫🥛👧",
  },
  {
    id: "tt0110912",
    emojiText: "💼🕺💉💃☕⌚",
  },
  {
    id: "tt0083658",
    emojiText: "🗡️🏃‍♂️",
  },
  {
    id: "tt4729430",
    emojiText: "📫🧓🔨🧸🛷",
  },
  {
    id: "tt2382320",
    emojiText: "🚫🕐💀",
  },
  {
    id: "tt1201607",
    emojiText: "👦⚡☠️⚔️2️⃣",
  },
  {
    id: "tt0095016",
    emojiText: "🗼🎄👨🔫",
  },
  {
    id: "tt0041959",
    emojiText: "🧍‍♂️🧍‍♂️🧍‍♂️⬅️",
  },
  {
    id: "tt0070047",
    emojiText: "✝️🤮🙏",
  },
  {
    id: "tt0266697",
    emojiText: "👱‍♀️⛩️⚔️",
  },
  {
    id: "tt0081505",
    emojiText: "🪓😈🛀",
  },
  {
    id: "tt10298810",
    emojiText: "👨‍🚀🌌",
  },
  {
    id: "tt0167404",
    emojiText: "👁️👀💀🧑‍🤝‍🧑",
  },
  {
    id: "tt9032400",
    emojiText: "🦸‍♂️🌍♾️",
  },
  {
    id: "tt0317705",
    emojiText: "👨‍👩‍👧‍👦🦸ℹ️",
  },
  {
    id: "tt6751668",
    emojiText: "👨‍👩‍👧‍👦💸🇰🇷",
  },
  {
    id: "tt0266543",
    emojiText: "🔎🐟",
  },
  {
    id: "tt0075148",
    emojiText: "🥊",
  },
  {
    id: "tt0112573",
    emojiText: "🏴󠁧󠁢󠁳󠁣󠁴󠁿⚔️😠☠️",
  },
  {
    id: "tt0816692",
    emojiText: "🚀🌊⏲️🌽",
  },
  {
    id: "tt0102926",
    emojiText: "🤐🐑",
  },
  {
    id: "tt0884328",
    emojiText: "🌫️🛒🌫️",
  },
  {
    id: "tt1375666",
    emojiText: "💤🌀⤴️",
  },
  {
    id: "tt0060196",
    emojiText: "👍👎👹",
  },
  {
    id: "tt0198781",
    emojiText: "🟢👁️🟢👧👹",
  },
  {
    id: "tt0892769",
    emojiText: "⚫🐉🦷",
  },
  {
    id: "tt0910970",
    emojiText: "🌍🗑️🤖🌱❤️",
  },
  {
    id: "tt8503618",
    emojiText: "🇺🇸🎼🗽🎵🔫",
  },
  {
    id: "tt0457430",
    emojiText: "👁️👐👁️",
  },
  {
    id: "tt0118715",
    emojiText: "🎳🥛💼🩲",
  },
  {
    id: "tt0169547",
    emojiText: "🇺🇸💅🌹🌹🌹🌹🌹🌹",
  },
  {
    id: "tt0056172",
    emojiText: "🏇🏜️🗡️",
  },
  {
    id: "tt1345836",
    emojiText: "🦇🤵⬆️",
  },
  {
    id: "tt0102926",
    emojiText: "🔇🐏",
  },
  {
    id: "tt1375666",
    emojiText: "💡➡😴",
  },
  {
    id: "tt0114709",
    emojiText: "🥔🤠👨‍🚀🐊🐖🐶",
  },
  {
    id: "tt0167260",
    emojiText: "💍🌋🧙‍♂️👑",
  },
  {
    id: "tt6139732",
    emojiText: "🧞‍♂️🪔🐒👸🤴",
  },
  {
    id: "tt0211915",
    emojiText: "👩‍🦰🎠🗼🥖🇫🇷",
  },
  {
    id: "tt1745960",
    emojiText: "✈️🇺🇸🕶️",
  },
  {
    id: "tt0109830",
    emojiText: "🏃🍫🦐",
  },
  {
    id: "tt0120382",
    emojiText: "🙍‍♂️🎥⛵😨📺",
  },
  {
    id: "tt4633694",
    emojiText: "🕷️🦸🦹🦸‍♂️🦹‍♂️🦸‍♀️🦹‍♀️🎨✏️",
  },
  {
    id: "tt0090605",
    emojiText: "👽🤰🩸😱",
  },
  {
    id: "tt0062622",
    emojiText: "👁️🖥️🛰️🚀",
  },
  {
    id: "tt0054215",
    emojiText: "🔪🚿🧓",
  },
  {
    id: "tt0101414",
    emojiText: "🌹👸🧌",
  },
  {
    id: "tt0264464",
    emojiText: "🏃‍♂️✈️💰🏃",
  },
  {
    id: "tt0045152",
    emojiText: "☔🎤😃",
  },
  {
    id: "tt0107290",
    emojiText: "🦟💉🥚🦕🦖🚨🏃‍♂️",
  },
  {
    id: "tt0382932",
    emojiText: "🐭💆‍♂️👨‍🍳🍲",
  },
  {
    id: "tt10648342",
    emojiText: "🦸🔨❤️➕⛈️",
  },
  {
    id: "tt0482571",
    emojiText: "🏃🚪🎩🚪🏃▶️👬",
  },
  {
    id: "tt2380307",
    emojiText: "🎸💀👦🇲🇽",
  },
  {
    id: "tt0107048",
    emojiText: "🔄⏰🦔",
  },
  {
    id: "tt0133093",
    emojiText: "🕵️🕵️‍♀️🤜🤵🔌💊",
  },
  {
    id: "tt1130884",
    emojiText: "👮‍♂️💊🏝️😨",
  },
  {
    id: "tt0114369",
    emojiText: "😋😛😴🤢😡😎🤤👀",
  },
  {
    id: "tt5311514",
    emojiText: "👦💬⁉️↔️⁉️🗨️👧🗾🌊☄️",
  },
  {
    id: "tt0119217",
    emojiText: "🧹🏫👨‍🏫🧠🍎",
  },
  {
    id: "tt12412888",
    emojiText: "🦔👟✌️",
  },
  {
    id: "tt0088763",
    emojiText: "🚗🔙⌚👨‍🔬🙍",
  },
  {
    id: "tt0435761",
    emojiText: "👨‍🚀🤠🏫🍓🧸",
  },
  {
    id: "tt0116629",
    emojiText: "🇺🇸🎆👽👊",
  },
  {
    id: "tt0325980",
    emojiText: "🏴‍☠️🌊💀⚔️⚫📿",
  },
  {
    id: "tt6467266",
    emojiText: "🐷🦍🦁🎹🎧🦔",
  },
  {
    id: "tt1160419",
    emojiText: "👩‍👦🗡️⏳🐛🪐",
  },
  {
    id: "tt0066921",
    emojiText: "👁️🎩🦯🥛🍊",
  },
  {
    id: "tt1049413",
    emojiText: "👴🧒🎈🏠🏞️🐕🔼",
  },
  {
    id: "tt0120338",
    emojiText: "💑🚢🧊🥶👵",
  },
  {
    id: "tt0050083",
    emojiText: "😠1️⃣2️⃣",
  },
  {
    id: "tt0073195",
    emojiText: "🦈😱",
  },
  {
    id: "tt0137523",
    emojiText: "🥊♣️🧼",
  },
  {
    id: "tt0088247",
    emojiText: "🤖🕶️🔫",
  },
  {
    id: "tt0110413",
    emojiText: "🧔🔫🥛👧",
  },
  {
    id: "tt0110912",
    emojiText: "💼🕺💉💃☕⌚",
  },
  {
    id: "tt0083658",
    emojiText: "🗡️🏃‍♂️",
  },
  {
    id: "tt4729430",
    emojiText: "📫🧓🔨🧸🛷",
  },
  {
    id: "tt2382320",
    emojiText: "🚫🕐💀",
  },
  {
    id: "tt1201607",
    emojiText: "👦⚡☠️⚔️2️⃣",
  },
  {
    id: "tt0095016",
    emojiText: "🗼🎄👨🔫",
  },
  {
    id: "tt0041959",
    emojiText: "🧍‍♂️🧍‍♂️🧍‍♂️⬅️",
  },
  {
    id: "tt0070047",
    emojiText: "✝️🤮🙏",
  },
  {
    id: "tt0266697",
    emojiText: "👱‍♀️⛩️⚔️",
  },
  {
    id: "tt0081505",
    emojiText: "🪓😈🛀",
  },
  {
    id: "tt10298810",
    emojiText: "👨‍🚀🌌",
  },
  {
    id: "tt0167404",
    emojiText: "👁️👀💀🧑‍🤝‍🧑",
  },
  {
    id: "tt9032400",
    emojiText: "🦸‍♂️🌍♾️",
  },
  {
    id: "tt0317705",
    emojiText: "👨‍👩‍👧‍👦🦸ℹ️",
  },
  {
    id: "tt6751668",
    emojiText: "👨‍👩‍👧‍👦💸🇰🇷",
  },
  {
    id: "tt0266543",
    emojiText: "🔎🐟",
  },
  {
    id: "tt0075148",
    emojiText: "🥊",
  },
  {
    id: "tt0112573",
    emojiText: "🏴󠁧󠁢󠁳󠁣󠁴󠁿⚔️😠☠️",
  },
  {
    id: "tt0816692",
    emojiText: "🚀🌊⏲️🌽",
  },
  {
    id: "tt0102926",
    emojiText: "🤐🐑",
  },
  {
    id: "tt0884328",
    emojiText: "🌫️🛒🌫️",
  },
  {
    id: "tt1375666",
    emojiText: "💤🌀⤴️",
  },
  {
    id: "tt0468569",
    emojiText: "🦸‍♂️🌃🃏🦇",
  },
  {
    id: "tt0071562",
    emojiText: "🕴️🇮🇹2️⃣🔫🐴",
  },
  {
    id: "tt0120737",
    emojiText: "💍🏔️🧝‍♂️🧙‍♂️🐉",
  },
  {
    id: "tt0167261",
    emojiText: "💍2️⃣🏞️🏰🔥",
  },
  {
    id: "tt0080684",
    emojiText: "🚀⭐⚔️❄️🤖",
  },
  {
    id: "tt0099685",
    emojiText: "🇮🇹🔫💵🍝👨‍👩‍👦‍👦",
  },
  {
    id: "tt0073486",
    emojiText: "🦅🛏️🏥🚁🏞️",
  },
  {
    id: "tt0047478",
    emojiText: "🇯🇵⚔️🌾🏰🌄",
  },
  {
    id: "tt0038650",
    emojiText: "🏡💕👼🎄💸",
  },
  {
    id: "tt0317248",
    emojiText: "🌆🇧🇷🔫🏚️",
  },
  {
    id: "tt0120815",
    emojiText: "🇺🇸🔫🔎👨‍🦱",
  },
  {
    id: "tt0118799",
    emojiText: "👨‍👦🇮🇹😄🌹",
  },
  {
    id: "tt0103064",
    emojiText: "🤖🔫2️⃣💥",
  },
  {
    id: "tt0407887",
    emojiText: "👮‍♂️🔫🐀🇮🇪",
  },
  {
    id: "tt1675434",
    emojiText: "🇫🇷👨‍🦽👨‍🦱🎵",
  },
  {
    id: "tt0027977",
    emojiText: "⚙️🏭🕰️😄",
  },
  {
    id: "tt0056058",
    emojiText: "🇯🇵🗡️🎎🏯",
  },
  {
    id: "tt0064116",
    emojiText: "🤠🏜️🚂🔫",
  },
  {
    id: "tt0047396",
    emojiText: "👀🔭🏢🚔",
  },
  {
    id: "tt0078748",
    emojiText: "👽🚀🏭🌌",
  },
  {
    id: "tt0095765",
    emojiText: "🎥🎞️🇮🇹💔",
  },
  {
    id: "tt0209144",
    emojiText: "⏮️🧩🔍📸",
  },
  {
    id: "tt0405094",
    emojiText: "🇩🇪👀🎧📝",
  },
  {
    id: "tt0043014",
    emojiText: "🌅🛣️🎥👩‍🦳",
  },
  {
    id: "tt0050825",
    emojiText: "🥾🏞️🎖️🇫🇷",
  },
  {
    id: "tt0032553",
    emojiText: "🌍🎩👨‍⚖️🎈",
  },
  {
    id: "tt0051201",
    emojiText: "🧐👩‍⚖️🕵️‍♂️📝",
  },
  {
    id: "tt0036775",
    emojiText: "🔄🔍💰👫",
  },
  {
    id: "tt0053604",
    emojiText: "🏢💘👨‍💼",
  },
  {
    id: "tt0086250",
    emojiText: "👨💊🔫🏙️",
  },
  {
    id: "tt0044741",
    emojiText: "👨🏻‍💼⏳🎢",
  },
  {
    id: "tt0070735",
    emojiText: "🎩💰🃏",
  },
  {
    id: "tt0056592",
    emojiText: "🕊️⚖️👧👦",
  },
  {
    id: "tt0119488",
    emojiText: "🔎🚔🚬🌆",
  },
  {
    id: "tt1832382",
    emojiText: "👫🏻💔🇮🇷",
  },
  {
    id: "tt0208092",
    emojiText: "💎🥊🐷",
  },
  {
    id: "tt1255953",
    emojiText: "🔥👩‍👧‍👦📜",
  },
  {
    id: "tt0097576",
    emojiText: "🤠🏺✝️",
  },
  {
    id: "tt0040522",
    emojiText: "🚲❌👨‍👦",
  },
  {
    id: "tt8579674",
    emojiText: "🌍⏳🔫🕊️1️⃣7️⃣",
  },
  {
    id: "tt0986264",
    emojiText: "👦📚🌟",
  },
  {
    id: "tt0363163",
    emojiText: "🇩🇪👨‍✈️⬇️",
  },
  {
    id: "tt10872600",
    emojiText: "🕷️👦🚫🏠",
  },
  {
    id: "tt0059578",
    emojiText: "💰💰🔫",
  },
  {
    id: "tt0372784",
    emojiText: "🦇👦🏙️",
  },
  {
    id: "tt5074352",
    emojiText: "🤼‍♀️🏅🇮🇳",
  },
  {
    id: "tt0012349",
    emojiText: "🧒🎩👫",
  },
  {
    id: "tt10272386",
    emojiText: "👴🧠🔄",
  },
  {
    id: "tt0042192",
    emojiText: "🎭👩🔝",
  },
  {
    id: "tt6966692",
    emojiText: "🚗🎵📗",
  },
  {
    id: "tt0055031",
    emojiText: "⚖️🇩🇪🕰️",
  },
  {
    id: "tt0042876",
    emojiText: "🌳🔪🎌🎭",
  },
  {
    id: "tt0477348",
    emojiText: "🏜️💼💰🔫",
  },
  {
    id: "tt0080678",
    emojiText: "🎩🐘😭💔",
  },
  {
    id: "tt0071315",
    emojiText: "🕵️🏙️💔🔪",
  },
  {
    id: "tt0031381",
    emojiText: "👩💔🌪️🏡",
  },
  {
    id: "tt0434409",
    emojiText: "✌️🎭💣🇬🇧",
  },
  {
    id: "tt0084787",
    emojiText: "❄️👾😱🔥",
  },
  {
    id: "tt0120735",
    emojiText: "🔒💼🔫💰",
  },
  {
    id: "tt0046912",
    emojiText: "☎️🔪😱🕵️",
  },
  {
    id: "tt1305806",
    emojiText: "👁️🔍💔⏳",
  },
  {
    id: "tt0050212",
    emojiText: "🌉🏞️⛓️💣",
  },
  {
    id: "tt0347149",
    emojiText: "🧙‍♂️🏰🔮🐺",
  },
  {
    id: "tt5027774",
    emojiText: "3️⃣🛑🔥💔",
  },
  {
    id: "tt1205489",
    emojiText: "🚗👴🔫🏠",
  },
  {
    id: "tt1291584",
    emojiText: "🤼‍♂️🥊👨‍👦‍👦🏆",
  },
  {
    id: "tt0116282",
    emojiText: "❄️🚗💵🔫",
  },
  {
    id: "tt1392214",
    emojiText: "👭🚐👮‍♂️🔍",
  },
  {
    id: "tt0405159",
    emojiText: "🥊💵🏆👧",
  },
  {
    id: "tt0015864",
    emojiText: "⛏️🏔️🤑🍞",
  },
  {
    id: "tt0047296",
    emojiText: "🚢⚓️🥊🐦",
  },
  {
    id: "tt0118849",
    emojiText: "🧒👟🏃‍♂️🏅",
  },
  {
    id: "tt0052618",
    emojiText: "👑🐎🛡️⛓️",
  },
  {
    id: "tt0017925",
    emojiText: "🚂👨‍✈️💣💔",
  },
  {
    id: "tt0112471",
    emojiText: "👫🌇💬❤️",
  },
  {
    id: "tt0050986",
    emojiText: "🍓👴🚗💭",
  },
  {
    id: "tt2267998",
    emojiText: "👩💍💌🔪",
  },
  {
    id: "tt0077416",
    emojiText: "🦌🏹🔫🇻🇳",
  },
  {
    id: "tt0107207",
    emojiText: "👨‍👦💣⚖️🇬🇧",
  },
  {
    id: "tt3011894",
    emojiText: "🦊📖💥💔",
  },
  {
    id: "tt1392190",
    emojiText: "😡🚗💥🏜️",
  },
  {
    id: "tt0978762",
    emojiText: "👧💌👴🇦🇺",
  },
  {
    id: "tt0019254",
    emojiText: "👩‍🌾🙏🔥⛪",
  },
  {
    id: "tt0097165",
    emojiText: "👨‍🏫📚💭🕊️",
  },
  {
    id: "tt0395169",
    emojiText: "🏨🇷🇼👨‍👩‍👧‍👦🔫",
  },
  {
    id: "tt0046438",
    emojiText: "👵👴🌆🎌",
  },
  {
    id: "tt0048473",
    emojiText: "👨‍👩‍👧‍👦🏞️🇮🇳💔",
  },
  {
    id: "tt0091763",
    emojiText: "👨‍👦‍👦🔫🌴🇻🇳",
  },
  {
    id: "tt1950186",
    emojiText: "🚘⚙️🏁🏆",
  },
  {
    id: "tt0092005",
    emojiText: "👦👦👦👦🛤️👑",
  },
  {
    id: "tt1895587",
    emojiText: "🔍📰⛪👥",
  },
  {
    id: "tt1979320",
    emojiText: "🏎️💨⏱️🏆",
  },
  {
    id: "tt0074958",
    emojiText: "📺💬🏙️🎭",
  },
  {
    id: "tt0758758",
    emojiText: "🚶‍♂️🌲🚌🌄",
  },
  {
    id: "tt3315342",
    emojiText: "👨🔪🚗👧",
  },
  {
    id: "tt0381681",
    emojiText: "💑🌅🇫🇷💬",
  },
  {
    id: "tt0036868",
    emojiText: "🇺🇸🎖️👨‍👩‍👧‍👦❤️",
  },
  {
    id: "tt0032976",
    emojiText: "👰🏰🔥💔",
  },
  {
    id: "tt0058946",
    emojiText: "🇩🇿💣🔫🏙️",
  },
  {
    id: "tt0032551",
    emojiText: "🍇😡👨‍👩‍👧‍👦🚚",
  },
  {
    id: "tt0061512",
    emojiText: "😎✋👷🥚",
  },
  {
    id: "tt0245712",
    emojiText: "🐶❤️🚗💥",
  },
  {
    id: "tt0113247",
    emojiText: "👨‍👨‍👦🏙️🔫💔",
  },
  {
    id: "tt0053198",
    emojiText: "👦💔🏃‍♂️🇫🇷",
  },
  {
    id: "tt0060827",
    emojiText: "👩‍⚕️👩🎭🏖️",
  },
  {
    id: "tt0476735",
    emojiText: "👨👦❤️💔",
  },
  {
    id: "tt0079470",
    emojiText: "👨‍🦱🙌✨😂",
  },
  {
    id: "tt0025316",
    emojiText: "🌃👫🚌💘",
  },
  {
    id: "tt0059742",
    emojiText: "🎵🏞️👩‍👧‍👦🇦🇹",
  },
  {
    id: "tt0071411",
    emojiText: "🧑🏔️🌲🇷🇺",
  },
  {
    id: "tt4016934",
    emojiText: "👩‍❤️‍👩📘🇰🇷🏰",
  },
  {
    id: "tt15097216",
    emojiText: "⚖️🇮🇳💼🗣️",
  },
  {
    id: "tt0083987",
    emojiText: "🇮🇳👳‍♂️☮️📚",
  },
  {
    id: "tt1454029",
    emojiText: "👩‍🦰📚👩‍🦱🥧",
  },
  {
    id: "tt3704428",
    emojiText: "🕺🎤🎸🇺🇸",
  },
  {
    id: "tt5113044",
    emojiText: "🍌🦹‍♂️🏢🌆",
  },
  {
    id: "tt10304142",
    emojiText: "🚲🌷🇳🇱🏛️",
  },
  {
    id: "tt9419884",
    emojiText: "🧙‍♂️💫🌀🌌",
  },
  {
    id: "tt7144666",
    emojiText: "📞⚫🕵️‍♂️👦",
  },
  {
    id: "tt8041270",
    emojiText: "🦖🌍🏰🦕",
  },
  {
    id: "tt4123432",
    emojiText: "🔮🐉🧙📜",
  },
  {
    id: "tt21059520",
    emojiText: "👧🖼️📷🔍",
  },
  {
    id: "tt13841850",
    emojiText: "👨👨‍🦱👨‍🦳🕴️",
  },
  {
    id: "tt8093700",
    emojiText: "👩👑⚔️🏰",
  },
  {
    id: "tt7131622",
    emojiText: "🎬🌟🌴💫",
  },
  {
    id: "tt13320622",
    emojiText: "🗺️🏙️🔍🕵️‍♂️",
  },
  {
    id: "tt12593682",
    emojiText: "🚄🔫💥🎯",
  },
  {
    id: "tt14549466",
    emojiText: "🔮🚀🔬⚖️",
  },
  {
    id: "tt5108870",
    emojiText: "🩸🦇🔬🧛‍♂️",
  },
  {
    id: "tt1649418",
    emojiText: "👤🔫🕵️‍♂️💼",
  },
  {
    id: "tt11128440",
    emojiText: "👔💼🛍️🗣️",
  },
  {
    id: "tt8178634",
    emojiText: "🇮🇳🔥⚔️🛤️",
  },
  {
    id: "tt9851854",
    emojiText: "👮‍♂️🎖️🇮🇳🔫",
  },
  {
    id: "tt2231253",
    emojiText: "🃏🎲🔫💰",
  },
  {
    id: "tt4998632",
    emojiText: "🚑🚨🏥🚔",
  },
  {
    id: "tt1323594",
    emojiText: "😈👧👧👧🍌",
  },
  {
    id: "tt14376344",
    emojiText: "💃🕺🎶🎈",
  },
  {
    id: "tt8323668",
    emojiText: "👴👵💰🎰",
  },
  {
    id: "tt0089218",
    emojiText: "🏴‍☠️🗺️💎👦",
  },
  {
    id: "tt4181158",
    emojiText: "👋👋💔💌",
  },
  {
    id: "tt1981115",
    emojiText: "🔨⚡🌌👑",
  },
  {
    id: "tt14145426",
    emojiText: "👦👦🚀🌌",
  },
  {
    id: "tt0134119",
    emojiText: "🎩🔎💼🔪",
  },
  {
    id: "tt1879016",
    emojiText: "💼🕵️‍♂️📜🕹️",
  },
  {
    id: "tt10954652",
    emojiText: "👵🏝️⏳👴",
  },
  {
    id: "tt12545566",
    emojiText: "📜🎩💕💌",
  },
];